import styled, { css } from 'styled-components';
import { getColor, typeScale, round } from 'core/utils';
import { resetBtn } from 'styled-manila';

export const Wrapper = styled.div`
	padding-bottom: ${typeScale(1)};
`;

export const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-gap: ${typeScale(2)};
	margin-bottom: ${typeScale(3)};
`;

export const TermBtn = styled.button`
	${resetBtn}
	background: ${getColor("white")};
	position: relative;
	padding: ${typeScale(4)} ${typeScale(2)} ${typeScale(2)};
	border: 1px solid ${getColor("gray3")};
	border-radius: 8px;
	text-align: left;

	${({ isSelected }) => isSelected && css`
		border-width: 3px;
		background-color: ${getColor("lightTeal")};
		border-color: ${getColor("primaryBrand")};
	`}
`;

export const Badge = styled.span`
	margin: 0;
	position: absolute;
	right: 8px;
	top: 8px;
	padding: 2px 6px;
	border-radius: 8px;
	display: block;
	font-weight: 700;
	font-size: 10px;
	line-height: ${round(12/10)};
	text-align: center;
	background-color: ${getColor("scandal")};
	color: ${getColor("watercourse")};
`;

export const TermLength = styled.h6`
	margin: 0;
	font-size: 16px;
	line-height: 1;
	margin-bottom: ${typeScale(1)};
`;

export const PricePerBox = styled.p`
	margin: 0;
	font-size: 16px;
	line-height: 1;
`;

export const Subtotal = styled.p`
	font-size: 18px;
	line-height: ${round(22/18)};
	font-weight: 700;
	margin: 0;
`;
